"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDivisions = exports.defaultDivisionData = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultDivisionData = exports.defaultDivisionData = {
  id: null,
  name: ''
};
const getDivisions = params => (0, _request.default)({
  url: '/divisions',
  method: 'get',
  params
});
exports.getDivisions = getDivisions;